// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
